import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  TimeScale,
  Title,
  Tooltip,
  TooltipItem,
} from 'chart.js';

import 'chartjs-adapter-dayjs-4/dist/chartjs-adapter-dayjs-4.esm';

import ChartDataLabels from 'chartjs-plugin-datalabels';

export const initChartJs = () => {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    TimeScale,
    PointElement,
    LineElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ChartDataLabels
  );
};

export const tooltipTitle = (items: TooltipItem<any>[]) => {
  const first = items.at(0);
  const label: string | string[] = first?.chart?.data?.labels?.[first?.parsed.x] as string | string[];

  return Array.isArray(label) ? label?.join(' ') : label;
};
